import React, { Fragment, useEffect, useState } from 'react';
import PlanCheckout from './PlanCheckout';
import { useDispatch, useSelector } from 'react-redux';
import useGenerateToken from 'components/Hook/useGenerateToken';
import { MobileCallbackTypes, ResponseCode, utils } from 'utils/Utils';
import { AsyncAjaxGet } from 'components/Common/AsyncAjaxService';
import Card from 'react-bootstrap/Card';
import Loader from 'components/Common/Loader';
import "../../Styles/SCSS/_plan.scss"
import useSession from "components/Hook/useSession";

const DesignServicePage = () => {
    const { BusinessID, ReactBusinessId, ReactUserID, UserID, CountryID, CurrencySymbol, NewCustomizedWebsitePrice } = useSelector((state) => state.Business);
    const dispatch = useDispatch();


    const [gotocheckout, setgotocheckout] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const [plans, setPlans] = useState([]);
    const [planID, setPlanID] = useState("");
    const [plan, setplan] = useState([]);
    const [originalPrices, setOriginalPrices] = useState(0);
    const [strikePrices, setStrikePrices] = useState(0);


    const VagaroAPIEnum = {
        GetVSitePlan: "merchants/" + BusinessID + "/vsiteplan?CountryID=" + CountryID,
    };

    const MobileCallBack = () => {
        window.setMobileData = (res) => {
            let Response = JSON.parse(res);
            if (Response.callbackIndex) {
                if (Response.callbackIndex == 69) {
                    if (Response.ReactReportIndex == 64 || Response.ReactReportIndex == 66 || Response.ReactReportIndex == 67) {
                        window.location.href = "/";
                    }
                    if (Response.ReactReportIndex == 65) {
                        setgotocheckout(false);
                        utils.CallBackGivenToMobileApp(MobileCallbackTypes.TitleWithBack, "Custom Website", 1, 64);
                    }
                }
            }
        }
    }

    const GetVSitePlans = async () => {
        const access_token = await useGenerateToken(dispatch);
        if (utils.Validate(access_token)) {
            setLoading(true);
            await AsyncAjaxGet(
                VagaroAPIEnum.GetVSitePlan,
                access_token,
                function onSuccess(data) {
                    try {
                        if (data != null && data.data != null && data.data.responseCode == ResponseCode.Success) {
                            if (data != null && data.data != null && data.data.data != null) {
                                var PlanData = data.data.data;
                                if (PlanData.length > 0) {
                                    setOriginalPrices(PlanData[0].originalPrices);
                                    setStrikePrices(PlanData[0].strikePrices);
                                }
                                setPlans(PlanData);
                                setLoading(false);
                                if (utils.IsFromProApp()) {
                                    utils.CallBackGivenToMobileApp(MobileCallbackTypes.TitleWithBack, "Custom Website", 1, 64);
                                }
                            }
                            else {
                                setLoading(false);
                            }
                        }
                        else {
                            setLoading(false);
                        }
                    }
                    catch (error) {
                        setLoading(false);
                        utils.appInsightTrack(
                            ReactBusinessId,
                            ReactUserID,
                            "Get All designer Plan Details",
                            null,
                            ""
                        );
                        utils.ShowAlert("Alert", "Something went wrong. Please refresh your browser and try again!", "OpenDialog", true);
                    }
                },
                function OnError() {
                    setLoading(false);
                    utils.appInsightTrack(
                        ReactBusinessId,
                        ReactUserID,
                        "Get Plan Details By Id",
                        null,
                        ""
                    );
                    utils.ShowAlert("Alert", "Something went wrong. Please refresh your browser and try again!", "OpenDialog", true);
                }
            );
        }
        else {
            utils.ShowAlert("Alert", "Something went wrong. Please refresh your browser and try again!", "OpenDialog", true);
        }
    }

    const CheckSession = async () => {
        setLoading(true);
        return await useSession(dispatch, BusinessID, UserID, (data) => {
            setLoading(false);
            if (data == true) {
                GetVSitePlans();
                if (utils.IsFromProApp()) {
                    MobileCallBack();
                }
            }
        });
    }

    useEffect(() => {
        CheckSession()
    }, [])


    return (
        <div>
            {isLoading && <Loader />}
            {!gotocheckout && !isLoading ?
                <Fragment>
                    <div class="plan-banner-bg">
                        <div class="plan-container">
                            <div class="plan-banner-row">
                                <div class="plan-bnr-left">
                                    <div class="mysite-logo">
                                        <img src="https://1a96a36bae7c8550901a-274b8a70320bb26e7a1e0ea7836ee429.ssl.cf2.rackcdn.com/PublicImages/Images/mysite-logo.svg" />
                                    </div>
                                    <div class="plan-bnr-tlt">Don’t want to do it yourself? Ask the Professionals!</div>
                                    <div class="plan-bnr-decs">
                                        Create your unique online presence with Vagaro's website builder, tailored to showcase your brand and effortlessly stay in sync with your business's latest updates, all in one platform.
                                    </div>
                                </div>
                                <div class="plan-bnr-right">
                                    <img class="plan-bnr-img" src="https://1a96a36bae7c8550901a-274b8a70320bb26e7a1e0ea7836ee429.ssl.cf2.rackcdn.com/PublicImages/Images/plan-banner-img.png" />
                                </div>
                            </div>
                        </div>
                    </div>
                    {strikePrices > 0 &&
                        <div class="design-services">
                            <div class="vg-plan-price">
                                {strikePrices !== originalPrices &&
                                    <del>{CurrencySymbol}{strikePrices}</del>
                                }
                                <span>{CurrencySymbol}{originalPrices}</span>
                            </div>
                            <div class="active-service">
                                Web Design Services when you activate MySite<br />
                                <em>Limited time offer</em>
                            </div>
                        </div>
                    }
                    <div class="expert-guidance-plan">
                        <div class="plan-container">
                            <div class="expert-plan-tlt">Expert Guidance, Unbeatable Prices.</div>
                            <div class="expert-plan-sub-tlt">Elevate your experience with premium pricing!</div>
                            <div class="plan-price-box">
                                {plans.map((data) => {
                                    return (
                                        <div className="vg-box" style={{ display: "flex", flexFlow: "column", justifyContent: "space-between" }} onClick={(e) => { setplan(data); setPlanID(data.encVagaroProductID); setgotocheckout(true); }}>
                                            <div>
                                                <div className='transfer-existing-web'><div className="vg-box-tlt">{data.productName}</div>{data.isShowNewButton ? <span className='new-badge-web-transfer'>New</span> : ""}<div></div></div>
                                                <div className="vg-box-decs">{data.description}</div>
                                                <div className="vg-free-plan">{data.sellPrice > 0 ? CurrencySymbol + data.sellPrice : "Free"}</div>
                                                <div style={{ color: "#15803D", textAlign: "center", fontWeight: "700", fontSize: "22px" }}>Design Services</div>
                                                {data.wbAmount > 0 &&
                                                    <div className="vg-free-plan" style={{ color: "#000000a6" }}><del>{CurrencySymbol + data.wbAmount}</del></div>
                                                }
                                            </div>
                                            <div>
                                                <hr />
                                                <div className="" style={{ alignItems: "center", fontWeight: "bold", fontSize: "20px" }}>+  {CurrencySymbol}{NewCustomizedWebsitePrice} Monthly subscription upon publishing</div>
                                                <div className='transfer-price-cart-button'><button style={{ textAlign: "center", marginTop: "24px" }} >Add to Cart</button></div>
                                            </div>

                                        </div>
                                    )
                                })}
                            </div>
                            <div class="plan-time-offer">Limited time offer</div>
                        </div>
                    </div>
                    <div class="plan-guidance-content first-plan-guidance">
                        <div class="plan-container">
                            <div class="plan-content-row">
                                <div class="plab-col plan-guide-img">
                                    <img class="common-plan-img" src='https://1a96a36bae7c8550901a-274b8a70320bb26e7a1e0ea7836ee429.ssl.cf2.rackcdn.com/PublicImages/Images/discover-stripe-img.png' alt='' />
                                </div>
                                <div class="plab-col plan-guide-decscription">
                                    <div class="plan-small-tlt">DISCOVER DESIGN SOLUTIONS</div>
                                    <div class="plan-large-tlt">Harnessing the Power of a Great Website!</div>
                                    <p class="plan-peragraph">A good website is a small business's 24/7 storefront and marketing engine. It's your digital presence that attracts customers, builds trust, and drives growth. Our design services team will collaborate with you to make sure your website serves to:</p>
                                    <div class="plan-listing">
                                        <ul>
                                            <li>Establish brand credibility that boosts trust in your customers</li>
                                            <li>Grow potential customer base by capturing information all from your website</li>
                                            <li>From customer forms to subscribing to your company emails , Vagaro makes it easy to implement into your website</li>
                                            <li>Having a well-designed website can have a competitive advantage against those in their industry</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="plan-guidance-content">
                        <div class="plan-container">
                            <div class="plan-content-row">
                                <div class="plab-col plan-guide-decscription">
                                    <div class="plan-small-tlt">EXPERT DESIGN SUPPORT</div>
                                    <div class="plan-large-tlt">What’s included in our Web Design Services?</div>
                                    <p class="plan-peragraph">Our in-house web designers will create your web page from start to finish ! Here’s what our team can offer :</p>
                                    <div class="plan-listing">
                                        <ul>
                                            <li>Up to 8 pages of custom designs for your business</li>
                                            <li>Customized website to your brand, ensuring it reflects your unique identity and objective</li>
                                            <li>Optimizing the site's layout, navigation, and functionality for a smooth and engaging user experience</li>
                                            <li>Already have a website you love? We can transfer it over! Our team will make the transfer so you can operate business as usual </li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="plab-col plan-guide-img">
                                    <img class="common-plan-img" src='https://1a96a36bae7c8550901a-274b8a70320bb26e7a1e0ea7836ee429.ssl.cf2.rackcdn.com/PublicImages/Images/expert-stripe-img.png' alt='' />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="plan-guidance-content experience-plan-decs">
                        <div class="plan-container">
                            <div class="plan-content-row">
                                <div class="plan-guide-decscription">
                                    <div class="plan-large-tlt">Experience the proficiency of our team.</div>
                                    <p class="plan-peragraph">Our design services team is experienced with designing compelling websites for businesses like yours. From Fitness brands to Salons and Spas, the Vagaro design services team understands how to deliver website your customers cant resist booking with!</p>
                                </div>
                                <div class="plan-guide-img">
                                    <img class="common-plan-img" src='https://1a96a36bae7c8550901a-274b8a70320bb26e7a1e0ea7836ee429.ssl.cf2.rackcdn.com/PublicImages/Images/experience-proficiency-img.png' alt='' />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="plan-guidance-content">
                        <div class="plan-container">
                            <div class="plan-content-row">
                                <div class="plab-col plan-guide-decscription">
                                    <div class="plan-small-tlt">DESIGN COLLABORATION</div>
                                    <div class="plan-large-tlt">Embrace the ease of design collaboration with our streamlined solutions.</div>
                                    <p class="plan-peragraph">Being a busy business owner, the task of constructing a website can often feel overwhelming and stressful. There are times when you're unsure about where to even begin. Allow our team of experienced web designers to shoulder this responsibility. They will craft and develop your website comprehensively, ensuring that your brand and business are the central focus of their designs.</p>
                                </div>
                                <div class="plab-col plan-guide-img">
                                    <img class="common-plan-img" src='https://1a96a36bae7c8550901a-274b8a70320bb26e7a1e0ea7836ee429.ssl.cf2.rackcdn.com/PublicImages/Images/design-collaboration-img.png' alt='' />
                                </div>
                            </div>
                        </div>
                    </div>
                </Fragment>
                :
                <Fragment>
                    <PlanCheckout Gotocheckout={setgotocheckout} PlanID={planID} plan={plan} />
                </Fragment>
            }
        </div >
    );
}

export default DesignServicePage;
